import { Category } from '../../models/interfaces/category.interface';

const TENANT_ID = 'tenant-uuid';

export const categoryMock: Category[] = [
  {
    id: 'category-uuid',
    tenantId: TENANT_ID,
    name: 'Tecnologia',
    description: 'Cursos de tecnologia e desenvolvimento',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-2',
    tenantId: TENANT_ID,
    name: 'Gestão',
    description: 'Cursos de gestão e liderança',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-3',
    tenantId: TENANT_ID,
    name: 'Design',
    description: 'Cursos de design e experiência do usuário',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-4',
    tenantId: TENANT_ID,
    name: 'Marketing',
    description: 'Cursos de marketing digital e comunicação',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-5',
    tenantId: TENANT_ID,
    name: 'Dados',
    description: 'Cursos de análise de dados e inteligência artificial',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-6',
    tenantId: TENANT_ID,
    name: 'Soft Skills',
    description: 'Cursos de comunicação, colaboração e desenvolvimento pessoal',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-7',
    tenantId: TENANT_ID,
    name: 'Finanças',
    description: 'Cursos de finanças corporativas e educação financeira',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
  {
    id: 'category-uuid-8',
    tenantId: TENANT_ID,
    name: 'Inovação',
    description: 'Cursos de inovação, produto e transformação digital',
    createdAt: new Date(),
    updatedAt: new Date(),
    isActive: true,
  },
];
